import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { filter, Subscription, take } from 'rxjs';
import { Actions, ofType } from '@ngrx/effects';
import { CustomerModel } from '../../../../models/customer.model';
import { Store } from '@ngrx/store';
import * as fromApp from '../../../../store/app.reducer';
import { createData } from '../create-object';
import * as AssignmentsActions from '../../store/assignments.actions';
import moment from 'moment';
import * as CompanyActions from '../../../company/store/company.actions';
import { DatePipe } from '@angular/common';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { L10n, setCulture, loadCldr } from '@syncfusion/ej2-base';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as gregorian from 'cldr-data/main/sv/ca-gregorian.json';
import * as numbers from 'cldr-data/main/sv/numbers.json';
import * as timeZoneNames from 'cldr-data/main/sv/timeZoneNames.json';
import * as weekData from 'cldr-data/supplemental/weekData.json';
import { GoogleMap } from '@angular/google-maps';
import { JobPlaceModel } from '../../../../models/jobPlace.model';
import { RegionModel } from '../../../../models/region.model';
import { HereSuggesstionModel } from '../../../../models/hereSuggesstion.model';
import { ScrollHandlerService } from './ScrollHandler.service';
import { GuardModel } from '../../../../models/guard.model';
import { PaginationModel } from '../../../../models/pagination.model';
import { customEmailValidator } from '../../../../shared/validators/email.validator';
import { MatMenuTrigger } from '@angular/material/menu';
import { CalendarComponent, RenderDayCellEventArgs } from '@syncfusion/ej2-angular-calendars';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../../../shared/snackbar/snackbar.service';
import { MatDialog } from '@angular/material/dialog';
import { AssigmentShiftSummaryCalculationComponent } from 'src/app/shared/components/assigment-shift-summary-calculation/assigment-shift-summary-calculation.component';
import { PhoneFormatService } from 'src/app/service/phone-format.service';
import * as AuthActions from 'src/app/auth/store/auth.actions'
import { GuardDetailsModalComponent } from 'src/app/shared/components/guard-details-modal/guard-details-modal.component';
import { PaymentModalComponent } from 'src/app/shared/components/payment-modal/payment-modal.component';
import { ConfettiService } from 'src/app/service/confetti.service';
import { LoadingService } from 'src/app/service/loading-service.service';
import { PaymentService } from 'src/app/shared/services/payment.service';

export function setupCalendarLocale() {
    const locale = localStorage.getItem('locale') || 'sv';

    moment.locale(locale);
    loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
    setCulture(locale);

    L10n.load({
        'en': {
            calendar: { today: 'Today', week: 'Week' },
            datepicker: { today: 'Today', week: 'Week' }
        },
        'en-US': {
            calendar: { today: 'Today', week: 'Week' }
        },
        'sv': {
            calendar: { today: 'Idag', week: 'Vecka' },
            datepicker: { today: 'Idag', week: 'Vecka' }
        },
        'sv-SE': {
            calendar: { today: 'Idag', week: 'Vecka' }
        }
    });
}

@Component({
    selector: 'app-step3',
    templateUrl: './step3.component.html',
    styleUrls: ['./step3.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class Step3Component implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('scrollableContainer') scrollableContainer!: ElementRef;
    show = false;
    minShiftDuration = 0;
    maxShiftDuration = 13;
    locale = 'sv';
    handPick: string = '1';
    today = new Date();
    minDatePicker = new Date(
        this.today.getFullYear(),
        this.today.getMonth(),
        this.today.getDate(),
    );
    initDates: Date[] = [];
    multiselect: Boolean = true;
    calendarDates: Date[];
    dates: any[] = [];
    assignmentType: string = '1';
    repeatEvery: string = 'MONTHLY';
    subscription: Subscription;
    customer: CustomerModel;
    recurringPatternForm = this.formBuilder.group({
        freq: 'MONTHLY',
        interval: '1',
        byMonthDay: '1',
    });
    isCreatingAssignmentFromHistory: boolean;
    numberOfGuard: number = 1;
    marker: {
        position: {
            lat: number,
            lng: number,
        }
    } = null;
    markerPosition: google.maps.LatLngLiteral = {
        lat: 59.33707555933145,
        lng: 18.07140391688358
    };
    pickedAddress: any;
    center: {
        lat: number,
        lng: number,
    } = null;
    searchAddressTimeout: any = null;
    addressSelectList = false;
    isJobOpen: boolean = false;
    searchJobs: string = '';
    allobjects: JobPlaceModel[];
    objects: JobPlaceModel[];
    regions: RegionModel[];
    regionsInSelectBox: RegionModel[];
    hereSuggestions: HereSuggesstionModel[];
    form = new UntypedFormGroup({
        object: new UntypedFormControl('')
    });
    @ViewChild('search', { static: true }) public searchElementRef: ElementRef;
    @ViewChild(GoogleMap, { static: false }) map: GoogleMap;
    @ViewChild('step3top') step3top!: ElementRef;
    statesSubscription: Subscription;
    employee: any;
    public contactForm = new UntypedFormGroup({
        name: new UntypedFormControl('', Validators.required),
        phone: new UntypedFormControl('', Validators.required),
        email: new UntypedFormControl('', [Validators.required, customEmailValidator()])
    });
    prices: any;
    private cachedFixedHourlyRate: number | null = null;
    private cachedFixedHourlyRateJobPlaceId: number | null = null;
    public guards: GuardModel[];
    public guardsPagination: PaginationModel;
    pagination: PaginationModel;
    public isLastPage: boolean;
    public selectedLeaders: number[] = [];
    public selectedPersonnelDetails: any[] = [];
    public selectedPersonnel: number[] = [];
    is_resetAllTime: Boolean = false;
    is_setAllDatesTime: Boolean = false;
    startTimeForAll: string = '08:00';
    endTimeForAll: string = '16:00';
    description: string = '';
    filterbyOption: string[] = ['create-assignment.step3.filter.previousWork', 'create-assignment.step3.filter.highestRated'];
    filterby: string = 'create-assignment.step3.filter.highestRated';
    searchGuards: string = '';
    searchGuardsTimeout: any;
    showAllRecords = true;
    public customers: CustomerModel[];
    @ViewChild('calendar') public calendarObj: CalendarComponent;
    durationHours: any
    selectedObject: any = null;
    /** Latest invoice details for the selected job place (from previous assignment API) */
    latestInvoiceForJobPlace: any = null;
    /** Full previous assignment data (has paymentMethod, billingReference, invoiceTime at top level) */
    previousAssignmentData: any = null;
    //Google map Option - with Map ID for AdvancedMarkerElement
    mapOptions: google.maps.MapOptions = {
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.TOP_LEFT,
        },
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        scaleControl: false,
        rotateControl: false,
        clickableIcons: false,
        mapId: 'DEMO_MAP_ID',  // Required for AdvancedMarkerElement
    };

    constructor(
        private store: Store<fromApp.AppState>,
        private formBuilder: UntypedFormBuilder,
        public datePipe: DatePipe,
        private cd: ChangeDetectorRef,
        public scrollService: ScrollHandlerService,
        private fb: UntypedFormBuilder,
        private snackbarService: SnackbarService,
        private dialog: MatDialog,
        private translate: TranslateService,
        private phoneFormatService: PhoneFormatService,
        private router: Router,
        private confettiService: ConfettiService,
        private actions$: Actions,
        private loadingService: LoadingService,
        private paymentService: PaymentService) {
        if (localStorage.getItem('locale')) {
            this.locale = localStorage.getItem('locale');
            setCulture(this.locale);
            L10n.load({ [this.locale]: { calendar: { today: 'Idag' } } });
        }
    }

    public storeBillingInformation = this.fb.group({
        contactName: ['', [Validators.required]],
        email: ['', [Validators.required, customEmailValidator()]],
    });

    get showBottomSheet() {
        return this.scrollService.showBottomSheet;
    }

    /** True when paymentMethod, billingReference and invoiceTime are all non-null and non-empty (then show edit billing button) */
    get showEditBillingButton(): boolean {
        const prev = this.previousAssignmentData;
        if (!prev || typeof prev !== 'object') return false;
        const paymentMethod = prev.payment_method ?? prev.paymentMethod;
        const billingReference = prev.billing_reference ?? prev.billingReference;
        const invoiceTime = prev.invoice_time ?? prev.invoiceTime;
        const notNull = (v: any) => v != null && v !== '';
        return notNull(paymentMethod) && notNull(billingReference) && notNull(invoiceTime);
    }

    ngOnInit(): void {
        // Suppress Google Maps deprecation warnings
        this.suppressGoogleMapsWarnings();

        setupCalendarLocale();
        this.store.select(state => state.auth).subscribe(authState => {
            this.customers = authState.employee?.customers ?? [];
            if (authState.employee?.customers?.length > 0) {
                this.filterbyOption = ['create-assignment.step3.filter.previousWork', 'create-assignment.step3.filter.highestRated'];
                this.filterby = 'create-assignment.step3.filter.previousWork';
            } else {
                this.filterbyOption = ['create-assignment.step3.filter.highestRated'];
                this.filterby = 'create-assignment.step3.filter.highestRated';
            }
        });
        this.store.dispatch(new AssignmentsActions.ClearGuards());
        this.subscription = this.store.subscribe(appState => {
            const previousCustomerId = this.customer?.id;
            this.customer = appState.auth.customer;
            if (this.customer?.id != null && previousCustomerId !== this.customer.id) {
                this.objects = [];
                this.allobjects = [];
                this.store.dispatch(new CompanyActions.LoadObjects({ customerId: this.customer.id }));
            }
            this.isCreatingAssignmentFromHistory = appState.assignments.isAssignmentCreatingFromHistory;
            this.guards = appState.assignments.guards;
            this.guardsPagination = appState.assignments.guardsPagination;
            this.pagination = appState.assignments.pagination;
            this.isLastPage = appState.assignments.guardsMeta.isLastPage;
        });
        this.store.select(state => state.auth.employee)
            .pipe(
                filter(x => x != null),
                take(1),
            )
            .subscribe(employee => {
                this.employee = employee;

                let name = '';
                if (employee.firstName && employee.lastName) {
                    name = employee.firstName + ' ' + employee.lastName;
                } else if (employee.firstName) {
                    name = employee.firstName;
                } else if (employee.lastName) {
                    name = employee.lastName;
                }

                // Only patch contact form email - name/phone are set by previousAssignments (API first, employee fallback)
                this.contactForm.patchValue({
                    email: employee.email,
                });

                // Patch billing info
                this.storeBillingInformation.patchValue({
                    contactName: this.customer?.billingInformation?.contactName || name || '',
                    email: this.customer?.billingInformation?.email || employee.email || ''
                });
            });

        if (createData.isRecurring) {
            this.assignmentType = '2';
            if (createData.recurrencePattern) {
                this.recurringPatternForm.controls['freq'].setValue(createData.recurrencePattern.freq);
                this.recurringPatternForm.controls['interval'].setValue(createData.recurrencePattern.interval);
                this.repeatEvery = this.recurringPatternForm.controls['freq'].value;
                if (createData.recurrencePattern.byMonthDay) {
                    this.recurringPatternForm.controls['byMonthDay'].setValue(createData.recurrencePattern.byMonthDay);
                }
            }
        } else {
            this.assignmentType = '1';
            createData.isRecurring = false;
        }
        if (createData.dates) {
            this.dates = createData.dates.map(el => Object.assign({}, el));
            this.initDates = this.dates.map(x => x.date);
        }
        createData.isManual = createData.isManual ? '1' : '0';
        createData.engagementType = this.handPick == '0' ? 1 : 2;
        createData.numberOfPersonnel = this.numberOfGuard;
        this.statesSubscription = this.store.select(state => state.company).subscribe(companyState => {
            this.objects = this.allobjects = companyState.objects;
            this.regions = companyState.regions;
            this.regionsInSelectBox = companyState.regions;
            this.hereSuggestions = companyState.hereSuggestions;
        });
        this.store.select(state => state.assignments).subscribe(assignmentsState => {
            if (this.cachedFixedHourlyRateJobPlaceId != null && this.cachedFixedHourlyRateJobPlaceId !== createData.jobPlaceId) {
                this.cachedFixedHourlyRate = null;
                this.cachedFixedHourlyRateJobPlaceId = null;
            }
            if (assignmentsState.price && createData.dates) {
                this.prices = assignmentsState.price;
                this.captureFixedHourlyRate(assignmentsState.price);
                this.cd.detectChanges();
            }
        });

        if (createData.skillId && createData.jobPlaceId) {
            this.store.dispatch(new AssignmentsActions.LoadPreviousAssignment({
                assignment_category_id: createData.assignmentCategoryId,
                skill_id: createData.skillId,
                job_place_id: createData.jobPlaceId
            }));
        }

        this.store.select(state => state.assignments.previousAssignments).subscribe((data: any) => {
            const employeeName = this.employee ? [this.employee.firstName, this.employee.lastName].filter(Boolean).join(' ') : '';
            const employeePhone = this.employee?.phone || '';

            // Use API data whenever it exists (regardless of hasPreviousAssignments - API can return contact info even when false)
            if (data?.data) {
                // data.data can be array or single object
                const prev = Array.isArray(data.data) && data.data.length > 0 ? data.data[0] : data.data;
                if (prev) {
                    if (data.hasPreviousAssignments) {
                        this.description = prev.description || '';
                        this.searchJobs = prev.jobplace?.address || '';
                    }

                    // Contact: prefer API response, fall back to employee only when API returns null
                    const prevContactName = prev.contactPersonName ?? (prev as any).contact_person_name;
                    const prevContactPhone = prev.contactPersonPhone ?? (prev as any).contact_person_phone;
                    const contactName = prevContactName || employeeName;
                    const contactPhone = prevContactPhone || employeePhone;
                    this.contactForm.patchValue({
                        name: contactName,
                        phone: contactPhone
                    });
                    createData.contactPersonName = contactName;
                    createData.contactPersonPhone = contactPhone;

                    // Store latest invoice details for this job place (API may return latestInvoice or latest_invoice)
                    this.latestInvoiceForJobPlace = prev?.latestInvoice ?? prev?.latest_invoice ?? null;
                    // Store full previous assignment (paymentMethod, billingReference, invoiceTime are at this level)
                    this.previousAssignmentData = prev;

                    // Patch Billing Information: prefer previous assignment billing reference, then latest invoice, else billing/customer/employee fallback
                    const prevBillingReference = prev?.billing_reference ?? prev?.billingReference;
                    if (prevBillingReference != null && prevBillingReference !== '') {
                        this.storeBillingInformation.patchValue({
                            contactName: prevBillingReference,
                            email: this.latestInvoiceForJobPlace?.invoiceEmail ?? this.customer?.billingInformation?.email ?? this.customer?.email ?? this.employee?.email ?? ''
                        });
                    } else if (this.latestInvoiceForJobPlace) {
                        this.storeBillingInformation.patchValue({
                            contactName: this.latestInvoiceForJobPlace.contactPerson ?? '',
                            email: this.latestInvoiceForJobPlace.invoiceEmail ?? ''
                        });
                    } else {
                        const billingInfo = this.customer?.billingInformation;
                        const empName = this.employee ? [this.employee.firstName, this.employee.lastName].filter(Boolean).join(' ') : '';
                        this.storeBillingInformation.patchValue({
                            contactName: billingInfo?.contactName || this.customer?.contactPerson || empName || '',
                            email: billingInfo?.email || this.customer?.email || this.employee?.email || ''
                        });
                    }

                    if (data.hasPreviousAssignments && prev.jobplace?.lat && prev.jobplace?.lng) {
                        this.selectedObject = prev.jobplace;
                        createData.jobPlaceId = prev.jobplace.id;
                        this.marker = {
                            position: {
                                lat: Number(prev.jobplace.lat),
                                lng: Number(prev.jobplace.lng)
                            }
                        };
                        this.center = {
                            lat: Number(prev.jobplace.lat),
                            lng: Number(prev.jobplace.lng)
                        };
                    }

                    if (createData.dates?.length > 0 && createData.jobPlaceId && createData.skillId) {
                        this.calculatePrice();
                    }
                    return;
                }
            }

            // No API data or no latestInvoice - reset billing info to current behavior (billing/customer -> employee)
            this.latestInvoiceForJobPlace = null;
            this.previousAssignmentData = null;
            const billingInfo = this.customer?.billingInformation;
            const employeeNameForBilling = this.employee ? [this.employee.firstName, this.employee.lastName].filter(Boolean).join(' ') : '';
            this.storeBillingInformation.patchValue({
                contactName: billingInfo?.contactName || this.customer?.contactPerson || employeeNameForBilling || '',
                email: billingInfo?.email || this.customer?.email || this.employee?.email || ''
            });
            if (employeeName || employeePhone) {
                this.contactForm.patchValue({
                    name: this.contactForm.get('name')?.value || employeeName,
                    phone: this.contactForm.get('phone')?.value || employeePhone
                });
                createData.contactPersonName = createData.contactPersonName || employeeName;
                createData.contactPersonPhone = createData.contactPersonPhone || employeePhone;
            }
        });
        this.store.dispatch(new AssignmentsActions.LoadPreviousAssignment({
            assignment_category_id: createData.assignmentCategoryId,
            skill_id: createData.skillId,
            job_place_id: createData.jobPlaceId,
            uniform_id: createData.uniformId
        }));
    }

    ngAfterViewInit() {
        setTimeout(() => {
            const weekHeader = document.querySelector('.e-calendar .e-week-header .e-week-number');
            if (weekHeader && !weekHeader.textContent.trim()) {
                weekHeader.textContent = this.translate.instant('create-assignment.step3.week');
            }
        }, 0);
        const today = new Date();
        this.calendarObj.navigateTo('Month', today);

        // Initialize Google Places Autocomplete early so it's ready when user types
        setTimeout(() => {
            this.initGooglePlacesAutocomplete();
        }, 500);
    }

    onRenderDayCell(args: RenderDayCellEventArgs) {
        const td = args.element as HTMLElement;
        if (!td.classList.contains('e-week-number')) {
            const span = td.querySelector('span') as HTMLElement;
            if (!span) return;
            if (!td.classList.contains('e-selected')) {

                if (!td.classList.contains('e-other-month')) {
                    const day = args.date.getDay();
                    if (day >= 1 && day <= 5) {
                        span.style.color = '#2563eb';
                    } else {
                        span.style.color = '';
                    }
                } else {
                    span.style.color = '#6b7280';
                }

            } else {
                span.style.color = '';
            }
        }

        // Week number cells (optional, same as before)
        if (td.classList.contains('e-week-number')) {
            const span = td.querySelector('span') as HTMLElement;
            if (!span) return;

            const row = td.parentElement;
            if (!row) return;

            const dayCells = Array.from(row.querySelectorAll('td')).filter(
                d => !d.classList.contains('e-week-number')
            );

            const hasWeekdayInCurrentMonth = dayCells.some(d => {
                const dayTd = d as HTMLElement;
                return !dayTd.classList.contains('e-other-month') && !dayTd.classList.contains('e-weekend');
            });

            if (hasWeekdayInCurrentMonth) {
                span.style.color = '#2563eb';
            } else {
                span.style.color = '#6b7280';
            }
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();

        // Clean up Google Places Autocomplete
        if (this.autocomplete) {
            google.maps.event.clearInstanceListeners(this.autocomplete);
            this.autocomplete = null;
        }

        // Restore console.warn
        this.restoreConsoleWarn();
    }

    onChangeCalendar(event: any) {
        this.calendarDates = event;
        this.calendarDates.forEach(date => {
            let startTime, endTime;

            if (this.is_resetAllTime) {
                startTime = moment(date).set('hour', 8).set('minute', 0).set('second', 0).format('hh:mm:ss')
                endTime = moment(date).set('hour', 16).set('minute', 0).set('second', 0).format('HH:mm:ss')
            } else {

                startTime = moment(date).isSame(moment(), 'day')
                    ? moment().add(10, 'minute')
                    : moment(date).set('hour', 16).set('minute', 0);
                endTime = moment(date).isSame(moment(), 'day')
                    ? moment().add(1, 'hour').add(10, 'minute')
                    : moment(date).set('hour', 21).set('minute', 0);
            }
            const isFound = this.dates.some(el => {
                return el.date == startTime.format('YYYY-MM-DD');
            });


            if (!isFound) {
                this.dates = [...this.dates]
                this.dates.push({
                    date: startTime.format('YYYY-MM-DD'),
                    startTime: startTime.format('HH:mm'),
                    endTime: endTime.format('HH:mm'),
                    startAt: startTime,
                    endAt: endTime,
                });
            }
        });

        this.calendarDates = this.calendarDates.sort((a, b) => {
            return moment(a).diff(moment(b), 'd');
        });


        let calendarDatesMapped = this.calendarDates.map(calendarDateItem => {
            return moment(calendarDateItem).format('YYYY-MM-DD');
        });
        this.dates = this.dates.filter(dateItem => {
            return calendarDatesMapped.includes(dateItem.date);
        }).sort((a, b) => {
            return moment(a.date).diff(moment(b.date), 'd');
        });
        if (!this.dates.length) {
            this.handPick = '1';
        }
        createData.dates = this.dates;
        createData.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.calculatePrice();
        setTimeout(() => {
            const calendar = document.querySelector('.e-calendar');
            if (!calendar) return;
            const dayCells = calendar.querySelectorAll('td.e-cell:not(.e-week-number)');
            dayCells.forEach(td => {
                const span = td.querySelector('span.e-day') as HTMLElement;
                if (!span) return;
                const cellDate = new Date(+td.id);
                const day = cellDate.getDay();
                const isSelected = td.classList.contains('e-selected') ||
                    this.dates.some(d => moment(d.date).format('YYYY-MM-DD') === moment(cellDate).format('YYYY-MM-DD'));

                if (td.classList.contains('e-other-month')) {
                    span.style.color = ''; // keep default
                } else {
                    if (isSelected) {
                        span.style.color = ''; // remove blue if selected
                    } else if (day >= 1 && day <= 5) {
                        span.style.color = '#2563eb'; // apply blue
                    } else {
                        span.style.color = '#2563eb';
                    }
                }
            });
        }, 0);
    }

    public onChangeSelect(event: any): void {
        this.repeatEvery = event;
        switch (this.repeatEvery) {
            case 'MONTHLY':
                createData.recurrencePattern.freq = 'MONTHLY';
                break;
            case 'WEEKLY':
                createData.recurrencePattern.freq = 'WEEKLY';
                delete createData.recurrencePattern.byMonthDay;
                break;
        }
    }

    public onChangeInterval(event: any): void {
        createData.recurrencePattern.interval = event;
    }

    public onChangeMonthDay(event: any): void {
        createData.recurrencePattern.byMonthDay = event;
    }

    public onChangeType(): void {
        switch (this.assignmentType) {
            case '1':
                createData.isRecurring = false;
                delete createData.recurrencePattern;
                break;
            case '2':
                createData.isRecurring = true;
                createData.recurrencePattern = {
                    interval: 1,
                    freq: 'MONTHLY',
                    byMonthDay: 1,
                };
                break;
        }
    }

    public onSetDateStartTime(event?: any, date?: string) {
        let startAtTime = event.target.value;
        this.dates = this.dates.map(el => {
            if (this.dates.map(x => x.date).indexOf(date) == 0) {
                event.target.value = startAtTime;
                return {
                    ...el,
                    startTime: startAtTime,
                    startAt: moment(new Date(el.date + 'T' + startAtTime)),
                };
            } else if (el.date == date) {
                event.target.value = startAtTime;
                return {
                    ...el,
                    startTime: startAtTime,
                    startAt: moment(new Date(el.date + 'T' + startAtTime)),
                };
            } else return el;
        });
        createData.dates = this.dates;
        this.calculatePrice();
    }
    public onSetDateEndTime(event?: any, date?: string) {
        const endTime = typeof event === 'string' ? event : event?.target?.value;

        this.dates = this.dates.map((el, index) => {
            if (this.dates.map(x => x.date).indexOf(date) == 0) {
                let endAt = moment(new Date(el.date + 'T' + endTime));
                const startAt = el.startAt ? moment(el.startAt) : null;

                if (startAt && !endAt.isAfter(startAt) && startAt.diff(endAt, 'minutes') > 5) {
                    endAt = endAt.add(1, 'day');
                }

                return {
                    ...el,
                    endTime,
                    endAt
                };
            }
            else if (el.date === date) {
                let endAt = moment(new Date(date + 'T' + endTime));
                const startAt = el.startAt ? moment(el.startAt) : null;

                if (startAt && !endAt.isAfter(startAt) && startAt.diff(endAt, 'minutes') > 5) {
                    endAt = endAt.add(1, 'day');
                }

                return {
                    ...el,
                    endTime,
                    endAt
                };
            }
            else {
                return el;
            }
        });

        createData.dates = this.dates;
        this.calculatePrice();
    }


    public toDate(string: string | number | Date): Date {
        return new Date(string);
    }

    public calculateTime(date: { date: string }, time1: string, time2: string): number {
        if ((!time1 && !time2) || !date) {
            return 0;
        }

        const dateTime1 = this.toDate(date.date + ' ' + time1);
        const dateTime2 = this.toDate(date.date + ' ' + time2);

        let MdateTime1 = moment(dateTime1);
        let MdateTime2 = moment(dateTime2);

        if (MdateTime1.isAfter(MdateTime2)) {
            MdateTime2 = MdateTime2.add(1, 'day');
        }
        return MdateTime2.diff(MdateTime1, 'minutes') / 60;
    }

    public calculateDurationTime(date: { date: string }, time1: string, time2: string): string {
        const dateTime1 = this.toDate(`${date.date} ${time1}`);
        const dateTime2 = this.toDate(`${date.date} ${time2}`);
        const MdateTime1 = moment(dateTime1);
        const MdateTime2 = moment(dateTime2);
        if (MdateTime1.diff(MdateTime2) > 0) {
            MdateTime2.add(1, 'days');
        }
        const diffMinutes = MdateTime2.diff(MdateTime1, 'minutes');
        if (diffMinutes === 0) return '0';
        const hoursDecimal = diffMinutes / 60;
        return parseFloat(hoursDecimal.toFixed(2)).toString();
    }

    onDecreaseGuard() {
        this.numberOfGuard -= 1;
        createData.numberOfPersonnel = this.numberOfGuard;
        this.calculatePrice();
    }

    numberOfGuardCount(event: { target: { value: any; }; }) {
        createData.numberOfPersonnel = event.target.value;
        this.calculatePrice();
    }

    onIncreaseGuard() {
        this.numberOfGuard += 1;
        createData.numberOfPersonnel = this.numberOfGuard;
        this.calculatePrice();
    }

    // Google Places Autocomplete
    private autocomplete: google.maps.places.Autocomplete | null = null;
    private originalConsoleWarn: typeof console.warn | null = null;
    private originalConsoleError: typeof console.error | null = null;

    // Check if message contains Google Maps deprecation warnings
    private isGoogleMapsDeprecationMessage(args: any[]): boolean {
        const fullMessage = args.map(arg => String(arg)).join(' ');
        return fullMessage.includes('google.maps.places.Autocomplete') ||
            fullMessage.includes('google.maps.places.PlaceAutocompleteElement') ||
            fullMessage.includes('google.maps.places.AutocompleteService') ||
            fullMessage.includes('google.maps.Marker') ||
            fullMessage.includes('utc_offset') ||
            fullMessage.includes('utc_offset_minutes') ||
            fullMessage.includes('As of March 1st, 2025') ||
            fullMessage.includes('As of February 21st, 2024') ||
            fullMessage.includes('As of November 2019') ||
            fullMessage.includes('deprecated') && fullMessage.includes('google');
    }

    // Suppress specific Google Maps deprecation warnings
    private suppressGoogleMapsWarnings(): void {
        if (this.originalConsoleWarn) return; // Already suppressed

        // Suppress console.warn
        this.originalConsoleWarn = console.warn.bind(console);
        console.warn = (...args: any[]) => {
            if (this.isGoogleMapsDeprecationMessage(args)) {
                return; // Suppress this warning
            }
            this.originalConsoleWarn!(...args);
        };

        // Also suppress console.error for these messages
        this.originalConsoleError = console.error.bind(console);
        console.error = (...args: any[]) => {
            if (this.isGoogleMapsDeprecationMessage(args)) {
                return; // Suppress this error
            }
            this.originalConsoleError!(...args);
        };
    }

    // Restore console.warn and console.error on destroy
    private restoreConsoleWarn(): void {
        if (this.originalConsoleWarn) {
            console.warn = this.originalConsoleWarn;
            this.originalConsoleWarn = null;
        }
        if (this.originalConsoleError) {
            console.error = this.originalConsoleError;
            this.originalConsoleError = null;
        }
    }

    // Initialize Google Places Autocomplete on the search input
    private initGooglePlacesAutocomplete(): void {
        // Only initialize once
        if (this.autocomplete) return;

        // Check if search element exists
        if (!this.searchElementRef?.nativeElement) return;

        this.autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
            componentRestrictions: { country: ['SE', 'IN'] },
            // types: ['address']
        });

        this.autocomplete.addListener('place_changed', () => {
            const place = this.autocomplete!.getPlace();
            if (place.geometry && place.geometry.location) {
                this.pickedAddress = place;
                this.searchJobs = place.formatted_address || place.name || '';

                this.marker = {
                    position: {
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng()
                    }
                };
                this.center = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                };

                this.onCreateObjectSubmit();
                this.calculatePrice();
                this.cd.detectChanges();
            }
        });
    }

    // Called when search input gets focus
    public onSearchFocus(): void {
        // Ensure autocomplete is initialized when input is focused
        this.initGooglePlacesAutocomplete();
    }

    // Hide Google autocomplete dropdown
    private hideGoogleAutocomplete(): void {
        const pacContainers = document.querySelectorAll('.pac-container');
        pacContainers.forEach(container => {
            (container as HTMLElement).style.visibility = 'hidden';
        });
    }

    // Show Google autocomplete dropdown
    private showGoogleAutocomplete(): void {
        const pacContainers = document.querySelectorAll('.pac-container');
        pacContainers.forEach(container => {
            (container as HTMLElement).style.visibility = 'visible';
            (container as HTMLElement).style.display = '';
        });
    }

    // Called when user pastes an address
    public onAddressPaste(event: ClipboardEvent): void {
        const pastedText = event.clipboardData?.getData('text')?.trim();
        if (!pastedText) return;

        // Wait for paste to complete
        setTimeout(() => {
            this.searchJobs = pastedText;

            // First check if pasted text matches any recent locations
            if (this.allobjects && this.allobjects.length > 0) {
                const matchingLocations = this.allobjects.filter(x =>
                    x.name?.toLowerCase().includes(pastedText.toLowerCase()) ||
                    x.address?.toLowerCase().includes(pastedText.toLowerCase()) ||
                    x.city?.toLowerCase().includes(pastedText.toLowerCase())
                );

                if (matchingLocations.length > 0) {
                    // Found matches in recent locations - show recent locations dropdown
                    this.objects = matchingLocations;
                    this.isJobOpen = true;
                    this.addressSelectList = true;
                    // Hide Google autocomplete dropdown
                    this.hideGoogleAutocomplete();
                    this.cd.detectChanges();
                    return; // Don't use Google autocomplete
                }
            }

            // No matches in recent locations - use Google autocomplete/geocoding
            this.isJobOpen = false;
            this.addressSelectList = false;

            // Ensure autocomplete is ready
            this.initGooglePlacesAutocomplete();

            const input = this.searchElementRef.nativeElement as HTMLInputElement;
            input.focus();

            // Trigger Google Autocomplete dropdown
            input.dispatchEvent(new KeyboardEvent('keydown', { key: ' ', bubbles: true }));
            input.dispatchEvent(new Event('input', { bubbles: true }));

            this.cd.detectChanges();

            // For detailed addresses (>40 chars), directly use geocoding
            if (pastedText.length > 40) {
                this.geocodeAndGetPlaceDetails(pastedText);
            }
        }, 100);
    }

    // Geocode address and get full place details for backend API
    private geocodeAndGetPlaceDetails(address: string): void {
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address: address }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
                const geocodeResult = results[0];

                // Use PlacesService to get full place details
                if (geocodeResult.place_id) {
                    // Create a temporary map div for PlacesService
                    const mapDiv = document.createElement('div');
                    const tempMap = new google.maps.Map(mapDiv);
                    const placesService = new google.maps.places.PlacesService(tempMap);

                    placesService.getDetails(
                        {
                            placeId: geocodeResult.place_id,
                            fields: ['place_id', 'name', 'formatted_address', 'address_components',
                                'geometry', 'types', 'utc_offset_minutes']
                        },
                        (place, placeStatus) => {
                            if (placeStatus === google.maps.places.PlacesServiceStatus.OK && place) {
                                this.handlePlaceSelection(place, address);
                            } else {
                                // Fallback: use geocode result directly
                                this.handleGeocodeResult(geocodeResult, address);
                            }
                        }
                    );
                } else {
                    this.handleGeocodeResult(geocodeResult, address);
                }
            } else {
                console.error('Geocoding failed:', status);
            }
        });
    }

    // Handle place selection from Places API
    private handlePlaceSelection(place: google.maps.places.PlaceResult, originalAddress: string): void {
        this.pickedAddress = place;
        this.searchJobs = place.formatted_address || originalAddress;

        if (place.geometry?.location) {
            this.marker = {
                position: {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                }
            };
            this.center = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            };
        }

        this.onCreateObjectSubmit();
        this.calculatePrice();
        this.cd.detectChanges();
    }

    // Handle geocode result as fallback
    private handleGeocodeResult(result: google.maps.GeocoderResult, originalAddress: string): void {
        // Convert geocode result to place-like object for backend compatibility
        const placeData: any = {
            place_id: result.place_id,
            name: originalAddress,
            formatted_address: result.formatted_address,
            address_components: result.address_components,
            geometry: {
                location: {
                    lat: () => result.geometry.location.lat(),
                    lng: () => result.geometry.location.lng()
                },
                viewport: result.geometry.viewport
            },
            types: result.types
        };

        this.pickedAddress = placeData;
        this.searchJobs = result.formatted_address || originalAddress;

        this.marker = {
            position: {
                lat: result.geometry.location.lat(),
                lng: result.geometry.location.lng()
            }
        };
        this.center = {
            lat: result.geometry.location.lat(),
            lng: result.geometry.location.lng()
        };

        this.onCreateObjectSubmit();
        this.calculatePrice();
        this.cd.detectChanges();
    }

    keyUpAddress(event: any): void {
        const value = event.target.value?.trim() || '';

        if (value === '') {
            // Reset to show full recent locations list
            this.objects = this.allobjects;
            this.addressSelectList = false;

            this.pickedAddress = null;
            this.center = null;
            this.marker = null;
            // this.handPick = '1';
            this.hideGoogleAutocomplete();
            this.cd.detectChanges();
            return;
        }

        clearTimeout(this.searchAddressTimeout);

        this.searchAddressTimeout = setTimeout(() => {
            if (this.isJobOpen) {
                if (this.searchJobs) {
                    this.objects = this.allobjects.filter(x =>
                        x.name.toLowerCase().includes(this.searchJobs.toLowerCase()) ||
                        x.address?.toLowerCase().includes(this.searchJobs.toLowerCase()) ||
                        x.city?.toLowerCase().includes(this.searchJobs.toLowerCase())
                    );
                    if (this.objects.length > 0) {
                        this.addressSelectList = true;
                    }
                    // Keep showing recent locations dropdown (with "No data found" if empty)
                    // Don't switch to Google autocomplete
                    this.hideGoogleAutocomplete();
                } else {
                    this.objects = this.allobjects;
                    this.addressSelectList = false;
                }
            } else {
                // Google Places Autocomplete mode - show suggestions
                this.pickedAddress = null;
                this.addressSelectList = false;

                // Make sure Google autocomplete is visible and initialized
                this.showGoogleAutocomplete();
                this.initGooglePlacesAutocomplete();
                this.cd.detectChanges();
            }
            this.calculatePrice();
        }, 100); // Reduced timeout for faster response
    }


    public onChangeObject(item): void {
        this.handPick = '1';
        this.form.controls['object'].setValue(item.id);
        createData.jobPlaceId = this.form.controls['object'].value;
        this.searchElementRef.nativeElement.value = item.address;
        this.searchJobs = item.address;
        this.selectedObject = item;
        // Clear previous assignment data for old job place so edit billing button hide/show updates for new job place
        this.previousAssignmentData = null;
        this.latestInvoiceForJobPlace = null;
        this.marker = {
            position: {
                lat: Number(this.objects.find(e => e.id == createData.jobPlaceId).lat),
                lng: Number(this.objects.find(e => e.id == createData.jobPlaceId).lng)
            }
        };

        this.center = {
            lat: Number(this.objects.find(e => e.id == createData.jobPlaceId).lat),
            lng: Number(this.objects.find(e => e.id == createData.jobPlaceId).lng)
        };

        this.store.dispatch(new AssignmentsActions.LoadPreviousAssignment({
            assignment_category_id: createData.assignmentCategoryId,
            skill_id: createData.skillId,
            job_place_id: item.id,
            uniform_id: createData.uniformId
        }));

        this.isJobOpen = false;
        this.cd.detectChanges();
        this.calculatePrice();
    }

    public openRecentLocations(): void {
        if (this.searchJobs && this.searchJobs.length < 15) {
            this.searchJobs = '';
            this.pickedAddress = null;
        }
        this.isJobOpen = !this.isJobOpen
        if (this.allobjects.length > 0) {
            this.objects = this.allobjects;
        } else {
            this.store.dispatch(new CompanyActions.LoadObjects({ customerId: this.customer.id }));
        }
    }

    public calculatePrice(): void {
        // Ensure skillId is required before making API call
        if (createData.skillId != null) {
            // Process dates to ensure startAt and endAt have seconds set to 0
            const processedDates = createData.dates?.map(date => {
                const processedDate = { ...date };

                // Ensure startAt has seconds set to 0
                if (processedDate.startAt) {
                    const startAtMoment = moment(processedDate.startAt);
                    processedDate.startAt = startAtMoment.seconds(0).milliseconds(0).toISOString();
                }

                // Ensure endAt has seconds set to 0
                if (processedDate.endAt) {
                    const endAtMoment = moment(processedDate.endAt);
                    processedDate.endAt = endAtMoment.seconds(0).milliseconds(0).toISOString();
                }

                return processedDate;
            }) || [];

            this.store.dispatch(new AssignmentsActions.CalculatePrice({
                customerId: this.customer.id,
                dates: processedDates,
                skillId: createData.skillId,
                timezone: createData.timezone,
                guardsNumber: createData.numberOfPersonnel,
                jobPlaceId: createData.jobPlaceId,
            }));
        }
        else {
            // Navigate back to step 2 if skillId is missing
            this.store.dispatch(new AssignmentsActions.UpdateStep(1));
            this.router.navigate(['/components/assignments/create-assignment/step1']);
        }
    }

    public selectHandPick(value: string): void {
        this.handPick = value;
        this.changeHandPick(value);
    }

    public changeHandPick(value?: any): void {
        this.store.dispatch(new AssignmentsActions.ClearGuards());
        if (!createData.dates.length) {
            this.snackbarService.showError(this.translate.instant('create-assignment.step3.select-assignment-to-cont'));
            this.handPick = '1';
            return;
        }
        const addressValid = !!this.center && !!this.marker;
        if (!addressValid) {
            this.snackbarService.showError(this.translate.instant('create-assignment.step3.select-joblocation-to-cont'));
            this.handPick = '1';
            return;
        }

        if (this.assignmentType == '2') {
            createData.isManual = false;
            createData.engagementType = 2;
        } else {
            createData.isManual = this.handPick == '0' ? false : true;
            createData.engagementType = this.handPick == '0' ? 1 : 2;
        }

        if (createData.dates.length && this.handPick == '0') {
            this.store.dispatch(new AssignmentsActions.LoadObjectGuards({
                jobPlaceId: createData.jobPlaceId,
                skillId: createData.skillId,
                uniformId: createData.uniformId,
                dates: createData.dates,
                timezone: createData.timezone,
                filterType: this.filterby === 'create-assignment.step3.filter.highestRated' ? 'highest_rated' : 'previously_worked',
                search: this.searchGuards
            }));
        }
    }

    get showingFilterText(): string {
        const highestRatedKey = this.translate.instant('create-assignment.step3.filter.highestRated');
        const previousWorkKey = this.translate.instant('create-assignment.step3.filter.previousWork');

        if (this.filterby === 'create-assignment.step3.filter.previousWork') {
            return this.translate.instant('create-assignment.step3.showingPreviousWork');
        }
        if (this.filterby === previousWorkKey) {
            return this.translate.instant('create-assignment.step3.showingPreviousWork');
        }

        if (this.filterby === highestRatedKey) {
            return this.translate.instant('create-assignment.step3.showingHighestRated');
        }
    }

    keyUpSearchGuards(event: any): void {
        if (event.target.value == '') {
            this.searchGuards = '';
            this.changeHandPick();
            return;
        }

        clearTimeout(this.searchGuardsTimeout);
        this.searchGuardsTimeout = setTimeout(() => {
            this.changeHandPick()
        }, 300);

    }

    onScrollGuards(event: any): void {
        const height2 = document.getElementById('hand-pick-id').scrollHeight;
        const elementHeight2 = document.getElementById('hand-pick-id').offsetHeight;
        const scrollBottom2 = document.getElementById('hand-pick-id').scrollTop;

        if (!this.isLastPage && (scrollBottom2 >= (height2 - elementHeight2) * 0.7)) {
            this.store.dispatch(new AssignmentsActions.LoadObjectGuards({
                jobPlaceId: createData.jobPlaceId,
                skillId: createData.skillId,
                uniformId: createData.uniformId,
                dates: createData.dates,
                timezone: createData.timezone,
            }));
        }
    }

    public onChangePersonnel(event: any): void {
        if (!this.selectedPersonnelDetails.find(p => p.id == event.id)) {

            this.selectedPersonnelDetails.push(event);
        } else {
            let index = this.selectedPersonnelDetails.indexOf(event);
            this.selectedPersonnelDetails.splice(index, 1);
        }
    }

    /** Swedish organisation number: 10 digits (559167-4089, 5591674089) or 12 digits (19630409-4078, 196304094078). */
    private isOrganisationNumberValid(value: string): boolean {
        if (!value || typeof value !== 'string') return true;
        const orgNumberRegex = /^([0-9]{6}|[0-9]{8})-?[0-9]{4}$/;
        return orgNumberRegex.test(value.trim());
    }

    /** True if the effective organisation number (for billing/modal) is valid or absent; false if present and invalid. Used to enable/disable Save & Continue. */
    get isOrganisationNumberValidForSave(): boolean {
        const org = (this.customer?.idNumber ?? '').toString().trim();
        return !org || this.isOrganisationNumberValid(org);
    }

    public onSave(): void {
        if (!this.dates.length) {
            this.snackbarService.showError(this.translate.instant('create-assignment.step3.select-assignment-to-cont'));
            return;
        }

        if (this.handPick === '0' && (!this.selectedPersonnelDetails || this.selectedPersonnelDetails.length === 0)) {
            this.snackbarService.showError(this.translate.instant('create-assignment.step3.select-at-least-one-worker'));
            return;
        }

        createData.description = this?.description;
        let isValid = true;

        this.dates.forEach(date => {
            if (this.calculateTime(date, date.startTime, date.endTime) < this.minShiftDuration) {
                isValid = false;
                return;
            }
            if (this.calculateTime(date, date.startTime, date.endTime) > this.maxShiftDuration) {
                isValid = false;
                return;
            }
        });
        if (!isValid) {
            this.snackbarService.showError(this.translate.instant('create-assignment.step3.invalid-shift-time-range'));
            return;
        }
        createData.dates = [...this.dates];
        createData.numberOfLeaders = 0;
        createData.leadersIds = [];
        createData.guardsIds = this.selectedPersonnelDetails.map(x => x.id) || [];

        // Always store the contact person phone from the form
        const phoneValue = this.contactForm.get('phone').value;
        if (!phoneValue || !String(phoneValue).trim()) {
            this.snackbarService.showError(this.translate.instant('create-assignment.step3.contact-phone-required'));
            return;
        }
        createData.contactPersonPhone = phoneValue;

        const contactPerson = this.contactForm.get('name').value;
        if (!contactPerson || !String(contactPerson).trim()) {
            this.snackbarService.showError(this.translate.instant('create-assignment.step3.contact-name-required'));
            return;
        }
        createData.contactPersonName = contactPerson;
        const contactNumber = this.contactForm.get('phone').value;
        const billingInformation = this.customer.billingInformation;
        const organisationNumber = (this.customer?.idNumber ?? '').toString().trim();
        // Only call billing API when we have a valid company number; backend errors when company number is null
        if (organisationNumber && this.isOrganisationNumberValid(organisationNumber)) {
            this.store.dispatch(new AuthActions.CreateBillingInfo({
                customerId: this.customer.id,
                ...billingInformation,
                companyNumber: organisationNumber,
                contactName: contactPerson,
                city: billingInformation?.city || this.customer.city,
                companyName: billingInformation?.companyName || this.customer.companyName,
                email: billingInformation?.email || this.customer.email,
                phone: contactNumber
            }));
        }

        // Ensure assignment category id is set so assignment creation from modal does not fail when 3 billing fields are missing
        createData.assignmentCategoryId = createData.assignmentCategoryId ?? (localStorage.getItem('selectedCategoryId') ? +localStorage.getItem('selectedCategoryId') : undefined);

        // Edit button case (job place has the 3 billing fields)
        if (this.showEditBillingButton) {
            const prev = this.previousAssignmentData;
            const paymentMethod = prev?.payment_method ?? prev?.paymentMethod;
            // When payment is card, open payment modal so user goes to Stripe (after they closed the edit modal and clicked Save & Continue)
            if (paymentMethod === 'card') {
                this.processCardPaymentForSaveAndContinue();
                return;
            }
            // No customer idNumber: open payment modal so user can enter organisation number (same as new job place flow)
            const customerOrgId = (this.customer?.idNumber ?? '').toString().trim();
            if (!customerOrgId) {
                this.openPaymentModalForSave();
                return;
            }
            // For invoice flow with existing billing fields, still persist them to job place on every save
            if (this.customer?.id && createData.jobPlaceId) {
                const billingReferenceFromForm = this.storeBillingInformation.get('contactName')?.value;
                const billingReference = (billingReferenceFromForm && billingReferenceFromForm.trim() !== '')
                    ? billingReferenceFromForm
                    : (prev?.billing_reference ?? prev?.billingReference ?? '');
                const invoiceTime = prev?.invoice_time ?? prev?.invoiceTime ?? 'next-month';
                const invoiceEmail =
                    this.latestInvoiceForJobPlace?.invoiceEmail ??
                    this.storeBillingInformation.get('email')?.value ??
                    this.customer?.email ??
                    '';
                this.store.dispatch(new AuthActions.StoreJobPlaceBillingInfo({
                    customerId: this.customer.id,
                    jobPlaceId: createData.jobPlaceId,
                    payment_method: paymentMethod ?? 'invoice',
                    billing_reference: billingReference,
                    invoice_time: invoiceTime,
                    invoice_email: invoiceEmail
                }));
            }
            // Invoice: create assignment and navigate without opening popup
            createData.timezone = createData.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
            createData.engagementType = createData.engagementType ?? (this.handPick === '0' ? 1 : 2);
            createData.numberOfPersonnel = createData.numberOfPersonnel ?? this.numberOfGuard;
            createData.uniformId = createData.uniformId ?? createData.uniform_id;
            this.store.dispatch(new AssignmentsActions.AddAssignment({
                customerId: this.customer.id,
                data: { ...createData }
            }));
            this.actions$.pipe(
                ofType(AssignmentsActions.ADD_ASSIGNMENT_SUCCESS, AssignmentsActions.ADD_ASSIGNMENT_FAILED),
                take(1)
            ).subscribe((action: any) => {
                if (action.type === AssignmentsActions.ADD_ASSIGNMENT_SUCCESS) {
                    const assignment = action.payload?.assignment;
                    const assignmentId = assignment?.assignmentId || assignment?.id;
                    if (!assignmentId) {
                        this.snackbarService.showError(this.translate.instant('assignment-id-missing'));
                        return;
                    }
                    // Same as payment modal invoice flow: create invoice after assignment exists
                    this.submitStep3InvoiceAfterAssignment(assignmentId, prev);
                    return;
                }
                this.snackbarService.showError(this.translate.instant('failed-create-assignment'));
            });
            return;
        }
        // New job place or job place without the 3 fields / null: open payment popup (submit blocked in modal when org number invalid)
        this.openPaymentModalForSave();
    }

    /** Opens the payment modal for Save and Continue flow. When openWithCardAndGoToStripe is true (Save & Continue with card from edit billing), modal pre-fills and redirects to Stripe. */
    private openPaymentModalForSave(openWithCardAndGoToStripe?: boolean): void {
        const selectedJobPlace = this.selectedObject || this.objects?.find((o: any) => o.id === createData.jobPlaceId);
        const prev = this.previousAssignmentData;
        const priceData: any = {
            prices: this.prices,
            estimatedPrice: this.prices?.estimatedPrice || 0,
            guardsNumber: this.prices?.guardsNumber || this.numberOfGuard || 0,
            numberOfDays: this.prices?.datesWithPrice?.length || 0,
            totalDuration: this.getTotalDurationFromDatesAsNumber(),
            ratePerHour: this.ratePerHour(this.prices?.datesWithPrice || []),
            datesWithPrice: this.prices?.datesWithPrice || [],
            dates: createData.dates,
            skillId: createData.skillId,
            jobPlaceId: createData.jobPlaceId,
            description: this.description,
            assignmentData: { ...createData },
            jobPlaceName: selectedJobPlace?.name || selectedJobPlace?.jobPlaceName || '',
            jobPlaceAddress: selectedJobPlace?.address || '',
            customerId: this.customer.id,
            customer: this.customer,
            employee: this.employee,
            latestInvoice: this.latestInvoiceForJobPlace
        };
        // Use reference from step3 form when user has entered it; otherwise previous assignment
        const billingRefFromForm = this.storeBillingInformation.get('contactName')?.value?.trim();
        const billingReferenceForModal = (billingRefFromForm && billingRefFromForm !== '')
            ? billingRefFromForm
            : (prev?.billing_reference ?? prev?.billingReference ?? '');
        if (openWithCardAndGoToStripe && prev) {
            priceData.openAndGoToStripe = true;
            priceData.editBillingValues = {
                paymentMethod: prev.payment_method ?? prev.paymentMethod,
                billingReference: billingReferenceForModal,
                invoiceTime: prev.invoice_time ?? prev.invoiceTime
            };
        } else {
            // So checkout modal shows the same reference user set on step3 (only when user set it)
            priceData.editBillingValues = {
                billingReference: billingReferenceForModal
            };
        }
        const dialogRef = this.dialog.open(PaymentModalComponent, {
            width: '600px',
            disableClose: true,
            data: priceData
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result && result.paymentSuccess) {
                this.snackbarService.showSuccess(this.translate.instant('guard-shift-details.common.assigment-create-successfully'));
                this.confettiService.setShowConfetti(true);
                this.router.navigate(['/components/assignments']);
                localStorage.removeItem('selectedCategoryId');
                localStorage.removeItem('selectedUniform');
            }
        });
    }

    /** Save & Continue with card from Step 3 without showing the payment modal */
    private processCardPaymentForSaveAndContinue(): void {
        const customerId = this.customer?.id;
        if (!customerId) {
            this.snackbarService.showError(this.translate.instant('customer-id-missing'));
            return;
        }
        const dates = Array.isArray(createData.dates) ? createData.dates : [];
        if (!dates.length) {
            this.snackbarService.showError(this.translate.instant('guard-shift-details.common.dates-required') || 'Assignment dates are required.');
            return;
        }
        const payload = {
            ...createData,
            contactPersonName: createData.contactPersonName ?? '',
            contactPersonPhone: createData.contactPersonPhone ?? '',
            timezone: createData.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
            engagementType: createData.engagementType ?? 2,
            numberOfPersonnel: createData.numberOfPersonnel ?? createData.guardsNumber ?? this.numberOfGuard ?? 1,
            dates,
            assignmentCategoryId: createData.assignmentCategoryId,
            numberOfLeaders: createData.numberOfLeaders ?? 0,
            leadersIds: createData.leadersIds ?? [],
            guardsIds: createData.guardsIds ?? []
        };

        this.loadingService.showLoader();
        this.store.dispatch(new AssignmentsActions.AddAssignment({
            customerId: customerId,
            data: payload,
        }));

        this.actions$.pipe(
            ofType(AssignmentsActions.ADD_ASSIGNMENT_SUCCESS, AssignmentsActions.ADD_ASSIGNMENT_FAILED),
            take(1)
        ).subscribe((action: any) => {
            if (action.type === AssignmentsActions.ADD_ASSIGNMENT_FAILED) {
                this.loadingService.hideLoader();
                this.snackbarService.showError(this.translate.instant('failed-create-assignment-short'));
                return;
            }
            const assignment = (action as AssignmentsActions.AddAssignmentSuccess).payload.assignment;
            const assignmentId = assignment?.assignmentId || assignment?.id;
            if (!assignmentId) {
                this.loadingService.hideLoader();
                this.snackbarService.showError(this.translate.instant('assignment-id-missing'));
                return;
            }

            const jobPlaceId = createData.jobPlaceId;
            const billingReferenceFromForm = this.storeBillingInformation.get('contactName')?.value;
            const billingReference = (billingReferenceFromForm && billingReferenceFromForm.trim() !== '')
                ? billingReferenceFromForm
                : (this.previousAssignmentData?.billing_reference ?? this.previousAssignmentData?.billingReference ?? '');
            const invoiceTime = this.previousAssignmentData?.invoice_time ?? this.previousAssignmentData?.invoiceTime ?? 'next-month';
            const invoiceEmail =
                this.latestInvoiceForJobPlace?.invoiceEmail ??
                this.storeBillingInformation.get('email')?.value ??
                this.customer?.email ??
                '';

            const afterStore = () => this.createCheckoutAndRedirect(assignmentId);
            if (this.customer?.id && jobPlaceId) {
                this.store.dispatch(new AuthActions.StoreJobPlaceBillingInfo({
                    customerId: this.customer.id,
                    jobPlaceId: jobPlaceId,
                    payment_method: 'card',
                    billing_reference: billingReference,
                    invoice_time: invoiceTime,
                    invoice_email: invoiceEmail
                }));
                this.actions$.pipe(
                    ofType(AuthActions.STORE_JOB_PLACE_BILLING_INFO_SUCCESS, AuthActions.STORE_JOB_PLACE_BILLING_INFO_FAILED),
                    take(1)
                ).subscribe(() => afterStore());
            } else {
                afterStore();
            }
        });
    }

    /**
     * When billing is already complete on step 3 (invoice + edit-billing path), mirror the payment modal:
     * POST /payments/invoice after the assignment is created.
     */
    private submitStep3InvoiceAfterAssignment(assignmentId: number, prev: any): void {
        const billingReferenceFromForm = this.storeBillingInformation.get('contactName')?.value;
        const billingReference = (billingReferenceFromForm && billingReferenceFromForm.trim() !== '')
            ? billingReferenceFromForm.trim()
            : (prev?.billing_reference ?? prev?.billingReference ?? '');
        const invoiceTimeRaw = prev?.invoice_time ?? prev?.invoiceTime ?? 'next-month';
        const billingStatus = invoiceTimeRaw === 'immediate'
            ? 'IMMEDIATELY_AFTER_SESSION'
            : 'BEGINNING_OF_NEXT_MONTH';
        const invoiceEmail =
            this.latestInvoiceForJobPlace?.invoiceEmail
            ?? this.latestInvoiceForJobPlace?.email
            ?? this.storeBillingInformation.get('email')?.value
            ?? this.customer?.email
            ?? '';
        const rawOrg = (this.customer?.idNumber ?? '').toString().trim();
        const orgNumber = rawOrg.replace(/-/g, '');
        if (!orgNumber) {
            this.snackbarService.showError(this.translate.instant('payment-modal.validation.organization-number-required'));
            return;
        }
        const eInvoiceRaw = this.latestInvoiceForJobPlace?.eInvoice ?? this.latestInvoiceForJobPlace?.e_invoice;
        const eInvoice = eInvoiceRaw ? 1 : 0;
        const estimatedPrice = this.prices?.estimatedPrice || 0;
        const invoicePayload = {
            orgNumber,
            assignmentId,
            contactPerson: billingReference,
            email: invoiceEmail,
            billingStatus,
            eInvoice,
            amount: estimatedPrice,
            currency: 'sek',
        };
        this.paymentService.submitAssignmentInvoice(invoicePayload as any).subscribe({
            next: () => {
                this.snackbarService.showSuccess(this.translate.instant('guard-shift-details.common.assigment-create-successfully'));
                this.confettiService.setShowConfetti(true);
                this.router.navigate(['/components/assignments']);
                localStorage.removeItem('selectedCategoryId');
                localStorage.removeItem('selectedUniform');
            },
            error: () => {
                // Snackbar handled in PaymentService.catchError
            }
        });
    }

    private createCheckoutAndRedirect(assignmentId: number): void {
        if (!assignmentId) {
            this.loadingService.hideLoader();
            this.snackbarService.showError(this.translate.instant('assignment-id-missing'));
            return;
        }
        const payload = { assignment_id: assignmentId };
        this.paymentService.createCheckoutSession(payload).subscribe({
            next: (response: any) => {
                const checkoutUrl = response.checkout_url;
                const checkoutSessionId = response.checkout_session_id;
                if (checkoutSessionId) {
                    localStorage.setItem('stripe_session_id', checkoutSessionId);
                }
                if (checkoutUrl) {
                    const newWindow = window.open(checkoutUrl, '_blank');
                    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                        this.snackbarService.showError(this.translate.instant('popups-blocked-for-checkout'));
                    }
                } else {
                    this.snackbarService.showError(this.translate.instant('checkout-url-missing'));
                }
                this.loadingService.hideLoader();
            },
            error: () => {
                this.loadingService.hideLoader();
                this.snackbarService.showError(this.translate.instant('checkout-session-failed'));
            }
        });
    }

    /** Opens the same payment/billing modal as step 4 (Redigera faktureringsuppgifter) */
    openBillingEditModal(): void {
        // Sync createData with current step 3 state so assignment creation from modal has required fields (dates, number_of_leaders, assignment_category_id, etc.)
        createData.contactPersonName = this.contactForm.get('name')?.value;
        createData.contactPersonPhone = this.contactForm.get('phone')?.value;
        createData.dates = this.dates && this.dates.length ? [...this.dates] : (createData.dates || []);
        createData.numberOfLeaders = 0;
        createData.leadersIds = [];
        createData.guardsIds = this.selectedPersonnelDetails?.map(x => x.id) || [];
        createData.description = this.description ?? createData.description;
        createData.assignmentCategoryId = createData.assignmentCategoryId ?? (localStorage.getItem('selectedCategoryId') ? +localStorage.getItem('selectedCategoryId') : undefined);
        const selectedJobPlace = this.selectedObject || this.objects?.find((o: any) => o.id === createData.jobPlaceId);
        const prev = this.previousAssignmentData;
        const priceData = {
            prices: this.prices,
            estimatedPrice: this.prices?.estimatedPrice || 0,
            guardsNumber: this.prices?.guardsNumber || this.numberOfGuard || 0,
            numberOfDays: this.prices?.datesWithPrice?.length || 0,
            totalDuration: this.getTotalDurationFromDatesAsNumber(),
            ratePerHour: this.ratePerHour(this.prices?.datesWithPrice || []),
            datesWithPrice: this.prices?.datesWithPrice || [],
            dates: createData.dates,
            skillId: createData.skillId,
            jobPlaceId: createData.jobPlaceId,
            description: this.description,
            assignmentData: { ...createData },
            jobPlaceName: selectedJobPlace?.name || selectedJobPlace?.jobPlaceName || '',
            jobPlaceAddress: selectedJobPlace?.address || '',
            customerId: this.customer?.id,
            customer: this.customer,
            employee: this.employee,
            latestInvoice: this.latestInvoiceForJobPlace,
            isEditBillingCase: true,
            editBillingValues: (() => {
                const billingRefFromForm = this.storeBillingInformation.get('contactName')?.value?.trim();
                const billingReference = (billingRefFromForm && billingRefFromForm !== '')
                    ? billingRefFromForm
                    : (prev?.billing_reference ?? prev?.billingReference ?? '');
                return prev ? {
                    paymentMethod: prev.payment_method ?? prev.paymentMethod,
                    billingReference,
                    invoiceTime: prev.invoice_time ?? prev.invoiceTime
                } : { billingReference: billingRefFromForm || '' };
            })()
        };
        this.dialog.open(PaymentModalComponent, {
            width: '600px',
            disableClose: true,
            data: priceData
        }).afterClosed().subscribe(result => {
            if (result && result.paymentSuccess) {
                this.snackbarService.showSuccess(this.translate.instant('guard-shift-details.common.assigment-create-successfully'));
                this.confettiService.setShowConfetti(true);
                this.router.navigate(['/components/assignments']);
                localStorage.removeItem('selectedCategoryId');
                localStorage.removeItem('selectedUniform');
            }
        });
    }

    public handPickButtonName(guard): string {
        const key = this.selectedPersonnelDetails.some(x => x.id === guard.id)
            ? 'create-assignment.step3.added'
            : 'create-assignment.step3.add';
        return this.translate.instant(key);
    }

    public isGuardSelected(guard: { id: any; }): boolean {
        return this.selectedPersonnelDetails.some(x => x.id === guard.id);
    }

    public resetToStandardHours(): void {
        this.is_resetAllTime = true;
        this.dates = this.dates.map(el => {
            if (el.date) {

                const startAtTime = moment(el.date).set('hour', 8).set('minute', 0).set('second', 0).format('hh:mm:ss')
                const endAtTime = moment(el.date).set('hour', 16).set('minute', 0).set('second', 0).format('HH:mm:ss')

                return {
                    ...el,
                    startTime: startAtTime,
                    endTime: endAtTime,
                    startAt: moment(new Date(el.date + 'T' + startAtTime)),
                    endAt: moment(new Date(el.date + 'T' + endAtTime))
                };
            }
            return { ...el };
        });

    }

    public sameTimeForAllDate(): void {
        this.is_setAllDatesTime = !this.is_setAllDatesTime
    }

    calculateDuration(start: string, end: string): string {
        if (!start || !end) return '00:00';
        const startMoment = moment(start, 'HH:mm');
        const endMoment = moment(end, 'HH:mm');
        const duration = moment.duration(endMoment.diff(startMoment));
        const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
        const minutes = duration.minutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    public onCreateObjectSubmit(): void {
        let data: any = {};
        data.name = this.pickedAddress.name;

        if (!this.pickedAddress) {
            this.snackbarService.showError(this.translate.instant('create-assignment.step3.invalid-address'));
            return;
        }

        data.googlePlaceId = this.pickedAddress.place_id;
        data.googlePlace = this.pickedAddress;

        // New job place has no previous assignment with 3 billing fields — hide edit billing button
        this.previousAssignmentData = null;
        this.latestInvoiceForJobPlace = null;
        this.store.dispatch(new CompanyActions.AddNewObject({
            customerId: this?.customer?.id,
            data: data,
        }));

    }
    onChangeFilterby(event?: any) {
        if (event.value === this.translate.instant('create-assignment.step3.filter.highestRated')) {
            this.filterby = "create-assignment.step3.filter.highestRated"
        } else {
            this.filterby = "create-assignment.step3.filter.previousWork"
        }
        this.changeHandPick();
    }

    private closeTimeout: any;

    openTooltip(trigger: MatMenuTrigger) {
        trigger.openMenu();
    }

    // Custom Email Validation Function
    isStep3Valid(): boolean {
        const hasDates = this.dates && this.dates.length > 0;
        const contactValid = this.contactForm.valid;
        const jobPlaceSelected = !!createData.jobPlaceId;
        const guardsValid = this.numberOfGuard > 0;
        const billingName = this.storeBillingInformation.value.contactName;
        const billingInfoValid = billingName != null && billingName.trim() !== '';
        const allDatesValid = this.dates.every(d => {
            if (!d.startTime || !d.endTime) return false;
            const durationHoursStr = this.calculateDurationTime(d, d.startTime, d.endTime);
            const durationHours = parseFloat(durationHoursStr);
            const durationMinutes = durationHours * 60;
            return durationMinutes <= 780;
        });
        const addressValid = !!this.center && !!this.marker;
        const result = (
            hasDates &&
            contactValid &&
            jobPlaceSelected &&
            guardsValid &&
            billingInfoValid &&
            allDatesValid &&
            addressValid
        );
        return result;
    }

    isEmailValid(email: string): boolean {
        const emailPattern = /^[\p{L}\p{N}.!#$%&'*+/=?^_`{|}~-]+@[\p{L}\p{N}-]+(\.[\p{L}\p{N}-]+)+$/u;
        return emailPattern.test(email);
    }

    //Function for open summary breakdown if date is selected form more than one
    openSummaryBreakModal() {
        this.dialog.open(AssigmentShiftSummaryCalculationComponent, {
            width: '800px',
            data: {
                summaryData: this.prices,
                isCreateAssignment: true,
            }
        });
    }

    onPhoneInput(event: any): void {
        const input = event.target.value;
        const formatted = this.phoneFormatService.formatSwedishPhoneNumber(input);
        event.target.value = formatted;
        this.contactForm.controls.phone.setValue(formatted, { emitEvent: false });
        this.contactForm.controls.phone.updateValueAndValidity();
    }

    get uniqueObjects() {
        return this.objects ? [...new Map(this.objects.map(obj => [obj.id, obj])).values()] : [];
    }

    openGuardDetailsModal(guardDetails: any) {
        this.dialog.open(GuardDetailsModalComponent, {
            data: guardDetails
        });
    }

    ratePerHour(priceData: any) {
        if (createData.jobPlaceId != null && this.cachedFixedHourlyRate != null &&
            this.cachedFixedHourlyRateJobPlaceId === createData.jobPlaceId) {
            return this.cachedFixedHourlyRate;
        }

        if (!priceData || priceData.length === 0) {
            return 0;
        }

        // Use fixed hourly rate from API when job place has fixed price (backend sets this)
        const fixedRate = this.prices?.hourlyRate ?? this.prices?.ratePerHour ?? (this.prices as any)?.hourly_rate ?? (this.prices as any)?.rate_per_hour;
        if (fixedRate != null && fixedRate > 0) {
            return parseFloat(Number(fixedRate).toFixed(2));
        }

        // hourly rate configured on the job place. Use it directly so that minor duration
        // differences (e.g. 5.00 h vs 5.02 h due to a 1-minute end-time tweak) do not
        // cause the displayed rate to drift away from the configured integer value.
        const allPerGuardRates = priceData
            .map((item: any) => item.customerPerShiftPerGuard ?? item.customer_per_shift_per_guard)
            .filter((r: any) => r != null && r > 0);
        if (allPerGuardRates.length === priceData.length && allPerGuardRates.length > 0) {
            const firstRate = allPerGuardRates[0];
            const allSame = allPerGuardRates.every((r: number) => Math.abs(r - firstRate) < 0.01);
            if (allSame && Number.isInteger(firstRate)) {
                return firstRate;
            }
        }

        // Calculate from estimatedPrice; round to nearest integer when very close (fixes 409.96 -> 410 for fixed price)
        if (this.prices?.estimatedPrice != null && this.prices.estimatedPrice > 0) {
            const totalDuration = this.getTotalDurationFromDatesAsNumber();
            const guardsNumber = this.prices?.guardsNumber || this.numberOfGuard || 1;
            if (totalDuration > 0 && guardsNumber > 0) {
                const rate = (this.prices.estimatedPrice / guardsNumber) / totalDuration;
                return this.roundToFixedPriceIfClose(rate);
            }
        }

        // Fallback: from datesWithPrice
        if (priceData.length === 1) {
            const item = priceData[0];
            const cost = item.customerPerShiftPerGuard ?? item.customer_per_shift_per_guard;
            if (item.duration && cost != null) {
                const rate = cost / item.duration;
                return this.roundToFixedPriceIfClose(rate);
            }
            return 0;
        }

        let totalCost = 0;
        let totalDuration = 0;
        priceData.forEach((item: any) => {
            const cost = item.customerPerShiftPerGuard ?? item.customer_per_shift_per_guard;
            if (item.duration && cost != null) {
                totalCost += cost;
                totalDuration += item.duration;
            }
        });
        if (totalDuration > 0) {
            const avgRate = totalCost / totalDuration;
            return this.roundToFixedPriceIfClose(avgRate);
        }
        return 0;
    }

    private captureFixedHourlyRate(price: any): void {
        if (!price || createData.jobPlaceId == null) {
            return;
        }
        const fixedRate = price?.hourlyRate ?? price?.ratePerHour ?? (price as any)?.hourly_rate ?? (price as any)?.rate_per_hour;
        if (fixedRate != null && fixedRate > 0) {
            const rounded = Math.round(fixedRate);
            const isFixedRate = Math.abs(fixedRate - rounded) < 0.05;
            if (!isFixedRate) {
                return;
            }
            this.cachedFixedHourlyRate = parseFloat(Number(rounded).toFixed(2));
            this.cachedFixedHourlyRateJobPlaceId = createData.jobPlaceId;
        }
    }

    /** When calculated rate is very close to a whole number, round to it (e.g. 409.96 -> 410 for fixed price) */
    private roundToFixedPriceIfClose(rate: number): number {
        const rounded = parseFloat(rate.toFixed(2));
        const nearestInt = Math.round(rounded);
        return Math.abs(rounded - nearestInt) < 0.05 ? nearestInt : rounded;
    }

    // Calculate total duration from API datesWithPrice array to match API calculation
    public getTotalDurationFromDates(): string {
        const duration = this.getTotalDurationFromDatesAsNumber();
        return parseFloat(duration.toFixed(2)).toString();
    }

    // Helper method to get total duration as number (used for calculations)
    private getTotalDurationFromDatesAsNumber(): number {
        // Use API duration data if available to ensure consistency with price calculation
        if (this.prices?.datesWithPrice && this.prices.datesWithPrice.length > 0) {
            const totalDuration = this.prices.datesWithPrice.reduce((sum: number, item: any) => {
                return sum + (item.duration || 0);
            }, 0);
            return totalDuration;
        }

        // Fallback to local dates calculation if API data not available
        if (!this.dates || this.dates.length === 0) {
            return 0;
        }

        // If single date, return its duration directly
        if (this.dates.length === 1) {
            const durationStr = this.calculateDurationTime(
                this.dates[0],
                this.dates[0]?.startTime,
                this.dates[0]?.endTime
            );
            return parseFloat(durationStr) || 0;
        }

        // If multiple dates, sum up all durations
        let totalHours = 0;
        this.dates.forEach((date: any) => {
            const durationStr = this.calculateDurationTime(
                date,
                date?.startTime,
                date?.endTime
            );
            const durationHours = parseFloat(durationStr);
            if (!isNaN(durationHours) && durationHours > 0) {
                totalHours += durationHours;
            }
        });

        return totalHours;
    }
}
